export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";